module.exports = __webpack_public_path__ + "static/media/paypal.18b73c51.svg";